import ArrowDropDownCircleOutlined from '@mui/icons-material/ArrowDropDownCircleOutlined';
import RadioButtonCheckedOutlined from '@mui/icons-material/RadioButtonCheckedOutlined';
import { s } from '../../format/schema';
import { defineFieldType, optionSettings } from '../card';
import { SelectInput } from './FillInput';
import { SelectSettingsPanel } from './SettingsPanel';
import { FIELD_WIDTH } from '../../format/fieldWidth';

export const select = defineFieldType({
  type: 'select',
  name: 'Select',
  valueKind: 'option',
  settings: s.strictObject({ ...optionSettings, display: s.enum(['select', 'radioButtons']).optional() }),
  defaults: { display: 'select' },
  defaultWidth: settings => (settings.display === 'radioButtons' ? FIELD_WIDTH.FULL : FIELD_WIDTH.THIRD),
  value: s.string().nullable(),
  emptyValue: null,
  hasDefaultValue: true,
  validations: ['required', 'unique'],
  operators: ['isFilled', 'isEmpty', 'anyOf', 'noneOf'],
  palette: [
    { name: 'Select', tooltip: 'One option from a dropdown', group: 'Choice', icon: ArrowDropDownCircleOutlined },
    {
      name: 'Radio buttons',
      tooltip: 'One option, all visible',
      group: 'Choice',
      icon: RadioButtonCheckedOutlined,
      settings: { display: 'radioButtons' },
    },
  ],
  isEmpty: value => value === null,
  comparable: value => [value],
  FillInput: SelectInput,
  fillLabel: settings => (settings.display === 'radioButtons' ? 'legend' : 'outlined'),
  settingsPanel: { at: 'general', Panel: SelectSettingsPanel },
});
